import { lotStore, syncQueue, idMapStore } from '../indexedDBService'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export async function syncLots() {
	const keys = await syncQueue.keys()

	for (const key of keys) {
		const action = await syncQueue.getItem(key)

		if (!action || !action.type) continue

		try {
			if (action?.type === 'LOT_ADD_OFFLINE') {
				try {
                    const { data, status } = await Axios.post('/api/lot/register', action.payload, {
                        headers: { auth: localStorage.getItem('jwt') }
                    })
                    if (status === 200) {
					    await idMapStore.setItem(key, data.lot._id)
                        await syncQueue.removeItem(key)
                        await lotStore.removeItem(key)
                    }
				} catch (error) {
					console.warn('Error al sincronizar animal offline:', error)
				}
			}

			if (action?.type === 'LOT_EDIT_OFFLINE') {
				try {
                    const { data, status } = await Axios.put('/api/lot/edit/' + key, action.payload, {
                        headers: { auth: localStorage.getItem('jwt') }
                    })
                    if (status === 200 || status === 264) {
                        await syncQueue.removeItem(key)
                        await lotStore.removeItem(key)
                    }
				} catch (error) {
					console.warn('Error al sincronizar edición de animal:', error)
				}
			}
		} catch (error) {
			console.warn(`Error al sincronizar acción offline (${action.type}):`, error)
		}
	}
}